<h2 mat-dialog-title>
  Ticket - Status Update
</h2>
<button type="button" class="btn btn-link modal-close" (click)="cancel()">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>
<mat-dialog-content>
  <form [formGroup]="TicketUpdateForm" class="">
      <div class="row my-2">             
        <div class="col-sm-6 mb-0 create-sector-field">
          <span class="form-label">Status</span>
          <mat-form-field>
            <mat-label>Select Status</mat-label>
            <mat-select formControlName="TicketStatus">
              <mat-option *ngFor="let ticketstatus of ticketStatusCategory" [value]="ticketstatus.value">
                {{ ticketstatus.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
          <div class="col-sm-6">
              <div class="mb-0">
                  <span class="black-text fs-14 mb-1">Comment</span>
                  <textarea formControlName="Comment" [required]="true" class="form-control custom-textarea bg-transparent" rows="3"></textarea>
              </div>
          </div>
           
      </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-sm-12 text-end">
      <button
        type="button"
        class="btn theme-btn-outline px-2 px-md-5"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button type="button" class="btn theme-btn ms-3 px-2 px-md-5" [disabled]="TicketUpdateForm.invalid" (click)="onSubmit()">Update Ticket</button>
    </div>
</div>
</mat-dialog-actions>